// Exporting these values to allow re-use in some component-specific code where
// additional overrides are needed.
export const INPUT_BASE_PADDING_Y_PX = {
    medium: 6,
    small: 2
};
export const MuiInputBase = {
    styleOverrides: {
        root: ({ theme })=>({
                backgroundColor: theme.palette.mode === 'light' ? theme.palette.common.white : 'inherit',
                paddingTop: `${INPUT_BASE_PADDING_Y_PX.medium}px !important`,
                paddingBottom: `${INPUT_BASE_PADDING_Y_PX.medium}px !important`,
                [`&.MuiInputBase-adornedStart`]: {
                    paddingTop: '5px !important',
                    paddingBottom: '5px !important'
                }
            }),
        sizeSmall: {
            paddingTop: `${INPUT_BASE_PADDING_Y_PX.small}px !important`,
            paddingBottom: `${INPUT_BASE_PADDING_Y_PX.small}px !important`
        },
        input: {
            paddingTop: '0px !important',
            paddingBottom: '0px !important'
        },
        inputSizeSmall: {
            paddingTop: '0px !important',
            paddingBottom: '0px !important'
        }
    }
};

//# sourceMappingURL=input-base.js.map